// extracted by mini-css-extract-plugin
export default {"page":"jF","wrapper":"kF","text":"lF","icons":"mF","icon":"nF","icon_text":"oF","carousel_wrapper":"pF","slide":"qF","image":"rF","arrows":"sF","prev":"tF","modal_root":"uF","x_mark":"vF","modal":"wF","images":"xF","main_image":"yF","name":"zF"};
    if(module.hot) {
      // 1715276856652
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  